import { Users, TrendingUp, Wallet, Hourglass } from "lucide-react";

const eur = (n) => `€${n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const CoursesSummary = ({ users, paidOf }) => {
  const withPlan = users.filter((u) => u.enrollment?.plan);
  const noPlan = users.length - withPlan.length;
  const incassato = users.reduce((a, u) => a + paidOf(u), 0);
  const daIncassare = withPlan.reduce((a, u) => a + (u.enrollment?.amount_due || 0), 0);
  const secondaRata = withPlan.filter((u) => u.enrollment?.plan === "installments" && (u.enrollment?.amount_due || 0) > 0).length;
  const items = [
    { k: "count", icon: Users, l: "Iscritti ai corsi", v: users.length, sub: noPlan ? `${noPlan} senza piano di pagamento` : "tutti con piano scelto" },
    { k: "expected", icon: TrendingUp, l: "Incasso previsto", v: eur(incassato + daIncassare), sub: `su ${withPlan.length} con piano scelto` },
    { k: "collected", icon: Wallet, l: "Già incassato", v: eur(incassato), c: "text-green-600" },
    { k: "due", icon: Hourglass, l: "Da incassare", v: eur(daIncassare), c: "text-amber-600", sub: secondaRata ? `${secondaRata} in attesa della 2ª rata` : "nessuna rata in sospeso" },
  ];
  return (
    <div data-testid="courses-summary" className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
      {items.map(({ k, icon: Icon, l, v, c, sub }) => (
        <div key={k} data-testid={`courses-summary-${k}`} className="rounded-xl border border-border bg-card p-4">
          <div className="flex items-center gap-2 text-xs text-muted-foreground mb-1"><Icon size={14} className="text-primary" /> {l}</div>
          <div className={`text-2xl font-medium ${c || "text-foreground"}`}>{v}</div>
          {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
        </div>
      ))}
    </div>
  );
};
